/**
 * Les espaces de la ponctuation française, rendues insécables.
 *
 * Un message s'écrit avec des espaces ordinaires (« Tu veux qu'on en parle ? ») : dans une bulle
 * étroite, le point d'interrogation ou le guillemet fermant tombait seul sur la ligne suivante.
 * On ne touche qu'à l'espace qui précède `? ! : ; »` et à celle qui suit `«` ; une adresse
 * (`https://…`) n'a pas d'espace avant ses deux-points, elle reste intacte.
 */
const NBSP = " "

export function frenchSpacing(text: string): string {
    return text.replace(/ (?=[?!:;»])/g, NBSP).replace(/« /g, `«${NBSP}`)
}
